import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { captureTouch } from "./services/acquisition";

captureTouch(); // kayıt edinim kanalı: dış yönlendirme / kampanya teması (memeet_acq)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
